











































import { Component, Vue } from "vue-property-decorator";
import { Auth } from "@aws-amplify/auth";
import { VueForm } from "@/types.d";
import { getModule } from "vuex-module-decorators";
import { emailValidationRules, requiredValidationRule } from "@/services/input-validation.service";
import AuthModule from "@/store/modules/auth";
import logger from "@/plugins/logger";

@Component
export default class Login extends Vue {
  private username = "";
  private password = "";
  private valid = true;
  private error = "";

  private authStore = getModule(AuthModule);

  private passwordRules = [requiredValidationRule("Password")];

  private emailRules = emailValidationRules;

  get form(): VueForm {
    return this.$refs.form as VueForm;
  }

  forgotPassword() {
    this.authStore.updateAuthn("forgotPassword");
  }

  login() {
    if (this.form.validate()) {
      this.doLogin();
    }
  }

  reset() {
    this.form.reset();
  }

  async doLogin() {
    try {
      const cognitoUser = await Auth.signIn(this.username.toLowerCase(), this.password);
      logger.info("sign in successful");

      /**
       * original logic:
       * @see https://github.com/aws-amplify/amplify-js/blob/master/packages/aws-amplify-vue/src/components/authenticator/SignIn.vue
       */
      if (cognitoUser.challengeName === "NEW_PASSWORD_REQUIRED") {
        logger.info("require new password");
        this.authStore.updateAuthn("requireNewPassword");
      } else {
        this.authStore.updateAuthn("signedIn");
      }

      this.authStore.login(cognitoUser);
      this.error = "";
    } catch (error) {
      this.authStore.login(null);
      logger.error(error);
      this.error = "Could not log you in.";
    }
  }
}
